// removed by extract-text-webpack-plugin
module.exports = {"alert":"_3cnq9cWsgFJdIuxChTwpLc","success":"WiHLVWNboJ5TH9vw2eGQQ","warning":"_1QFT8CJAclA3YfQzNaJtJx","danger":"_3FE70WV85GGgbv7ypUfKTZ","neutral":"_2mHRdOS9FcXAprCaX1y-BU"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Alert/style.css
// module id = 480
// module chunks = 38